<script lang="ts">
  import { api } from '$shared/api';
  import LoadingSkeleton from '$shared/LoadingSkeleton.svelte';

  interface VoteEntry {
    id: number;
    track_id: number;
    track_name: string;
    track_username: string;
    duel_id: number;
    duel_name: string;
    is_top_pick: boolean;
    voted_at: string;
  }

  let votes = $state<VoteEntry[]>([]);
  let loading = $state(true);

  $effect(() => {
    api
      .get<{ votes: VoteEntry[] }>('/users/current/votes')
      .then((d) => {
        votes = d.votes || [];
        loading = false;
      })
      .catch((e: unknown) => {
        console.error('Failed to load votes:', e);
        loading = false;
      });
  });
</script>

<div>
  <h1>My Votes</h1>
  {#if loading}
    <LoadingSkeleton lines={6} />
  {:else if votes.length === 0}
    <p class="empty">You haven't cast any votes yet.</p>
  {:else}
    <div class="vote-list">
      {#each votes as vote}
        <div class="vote-row">
          <div class="vote-info">
            <div class="vote-header">
              <a href="#/tracks/{vote.track_id}" class="vote-track">{vote.track_name || 'Untitled'}</a>
              {#if vote.is_top_pick}<span class="badge-top-pick">Top Pick</span>{/if}
            </div>
            <div class="vote-meta">
              by <span class="vote-artist">{vote.track_username}</span>
              in <a href="#/duels/{vote.duel_id}/leaderboard">{vote.duel_name}</a>
            </div>
          </div>
          <span class="vote-date">{new Date(vote.voted_at).toLocaleDateString()}</span>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  h1 {
    margin-bottom: 1.5rem;
  }
  .empty {
    color: var(--text-secondary);
  }
  .vote-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .vote-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.75rem;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius);
  }
  .vote-info {
    flex: 1;
    min-width: 0;
  }
  .vote-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .vote-track {
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vote-track:hover {
    color: var(--cyan);
  }
  .badge-top-pick {
    font-size: 0.625rem;
    font-weight: 700;
    text-transform: uppercase;
    background: var(--pink);
    color: #fff;
    padding: 0.125rem 0.375rem;
    border-radius: 4px;
    white-space: nowrap;
  }
  .vote-meta {
    margin-top: 0.25rem;
    font-size: 0.8125rem;
    color: var(--text-secondary);
  }
  .vote-meta a:hover {
    color: var(--cyan);
  }
  .vote-artist {
    color: var(--text);
  }
  .vote-date {
    font-size: 0.75rem;
    color: var(--text-muted);
    white-space: nowrap;
  }
</style>
